module.exports = __webpack_public_path__ + "static/media/Percentage Match.ac008d44.svg";